angular.module('impactx.imageUpload').controller('ImageEditorCtrl', [
    '$scope',
    'FileHelperService',
    '$timeout',
    '$mdDialog',
    'themeFactory',
    'TranslationService',
    ImageEditorController
]);

function ImageEditorController($scope, FileHelperService, $timeout, $mdDialog, themeFactory, TranslationService) {
    var self = this;
    self.currentTheme = themeFactory.getTheme();
    self.areaType = self.areaType || 'circle';
    self.fullImage = {label: TranslationService.get('imageCropCompleteImage'), value: false};
    self.deleted = false

    self.delete = function () {
        $scope.currentImage = 'img/profile_image_default.png';
        if(self.fullImage.value) {
            $scope.uploadedImage = null;
        } else {
            $scope.croppedImage = null;
        }
        self.deleted = true;
    }

    self.upload = function () {
        var handleFileSelect = function (evt) {
            var file = evt.currentTarget.files[0];
            $scope.fileName = file.name;
            if (!FileHelperService.checkImageFileWithError(file.name)) {
                return;
            }
            var reader = new FileReader();
            reader.onload = function (evt) {
                $scope.$evalAsync(function ($scope) {
                    $scope.uploadedImage = evt.target.result;
                    self.deleted = false;
                });
            };
            reader.readAsDataURL(file);
        };
        $timeout(function () {
            angular.element(document.querySelector('#fileInput')).click();
        });
        angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);
    };

    self.closeDialog = function () {
        $mdDialog.hide();
    };

    self.saveDialog = function () {
        let imgObj = self.deleted ? { deleted: true } : { image: self.fullImage.value ? $scope.uploadedImage : $scope.croppedImage, name: $scope.fileName };
        $mdDialog.hide(imgObj);
    };

    self.trns = {
        apply: TranslationService.get('accept'),
        abort: TranslationService.get('abort'),
        editImage: TranslationService.get('editImage'),
        currentImage: TranslationService.get('currentImage'),
        newImage: TranslationService.get('newImage'),
        selectImage: TranslationService.get('selectImage'),
        deleteImage: TranslationService.get('deleteImage'),
    };

    if(impactX.isDefined(self, 'currentImage.url')) {
        $scope.currentImage = self.currentImage.url;
    }
    else if(impactX.isDefined(self, 'currentImage')) {
        $scope.currentImage = !angular.equals({}, self.currentImage) ? self.currentImage : undefined;
    }
    else {
        $scope.currentImage = "";
    }

    if(self.newImage) {
        var reader = new FileReader();
        reader.onload = function (evt) {
            $scope.$evalAsync(function ($scope) {
                $scope.uploadedImage = evt.target.result;
            });
        };
        reader.readAsDataURL(self.newImage);
        $scope.fileName = self.newImage.name;
    } else {
        $scope.uploadedImage = '';
    }
    $scope.croppedImage = '';
}